export default "__VITE_ASSET__0be24a9f__"